import React from 'react';
import * as d3 from "d3";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    withRouter
} from 'react-router-dom'

import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    RadialBar,
    RadialBarChart,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
    ZAxis,
    ReferenceLine,
    Scatter,
    ScatterChart,
    LabelList,
    Label
} from 'recharts';


var getXReferencePosition = function (data) {
    return d3.mean(data, function (d) { return d.xvalue; });
};

var getYReferencePosition = function (data) {
    return d3.mean(data, function (d) { return d.yvalue; });
};

var getPageViewFactorRange = function (data) {
    //todo: i could calcluate this from the page view factor
    return [50, 200];
};


class SeriesCompareScatterChart extends React.Component {

    constructor(props) {
        super(props);
        this.state = { testMetrics: null }

        this.handleClick = this.handleClick.bind(this);
    }


    static propTypes = {
        className: PropTypes.string,
        onItemClick: PropTypes.func

    };

    handleClick = (payload) => {
        const { onItemClick } = this.props;
        const pageId = payload.id;
        const url = `/pages/${pageId}/show`;
        this.props.history.push(url);

        if (onItemClick) {
            onItemClick(payload);
        }
    }

    render() {

        let body = [];

        this.props.series.forEach((record, index) => {
            //debugger;
            const scatter = <Scatter isAnimationActive={false} name={record.title} key={index} xAxisId='val' yAxisId='vis' zAxisId='pvf' data={record.data} fill={record.fillColor} onClick={this.handleClick} >
                <LabelList dataKey='title' position='top' />
            </Scatter>;

            body.push(scatter);

            const xLine = <ReferenceLine key={"x_" + record.id + "_" + index} x={getXReferencePosition(record.data)} xAxisId='val' stroke="green" alwaysShow />;
            body.push(xLine);

            const yLine = <ReferenceLine key={"y_" + record.id + "_" + index} y={getYReferencePosition(record.data)} yAxisId='vis' stroke="green" alwaysShow />;
            body.push(yLine);
        });

        return (
            <div>
                <ScatterChart width={this.props.width} height={this.props.height} margin={{ top: 10, right: 10, left: 20, bottom: 20 }}>
                    <XAxis xAxisId='val' domain={[0, 'dataMax + 10']} dataKey='xvalue' name='xvalue' type="number" unit=''>
                        <Label value='Engagement Value' position='bottom' />
                    </XAxis>
                    <YAxis yAxisId='vis' domain={[0, 'dataMax + 10']} dataKey='yvalue' name='yvalue' type="number" unit=''>
                        <Label value='Visits' position='left' offset={-10} angle={-90} />
                    </YAxis>
                    <ZAxis zAxisId='pvf' range={getPageViewFactorRange(this.props.series)} dataKey='density' type='number' />
                    <Legend verticalAlign='top' />
                    {body}
                    <CartesianGrid />
                    <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                </ScatterChart>
            </div>
        );
    }
}


// SeriesCompareScatterChart.defaultProps = {
//     style: {
//         width: 760,
//         height: 350
//     },
//     series: []
// };

export default withRouter(SeriesCompareScatterChart);


// WEBPACK FOOTER //
// ./src/components/charts/SeriesCompareScatterChart.js